import React from 'react';

export default function MyAccountCardField(props) {
    const classes = ['my-account-card-field'];
    if (props.vertical) {
        classes.push('vertical')
    }
    return (
        <div className={classes.join(' ')}>
            <div className="my-account-card-field-label">{props.label}</div>
            <div className="my-account-card-field-value">
                {props.children}
            </div>
        </div>
    )
}